import { SampleShiftCoverage } from 'src/app/enums/sampleShiftType.enum';

export interface SampleCollectionMetricsRequest {
  organizationLevelId?: string;
  timeRange: number;
  granularity: number;
  stackBy: number;
  agentGroupId?: string;
  agentIds?: string[];
  segIds?: string[];
  surveyTypeIds?: string[];
  customStartDate?: string;
  customEndDate?: string;
  shiftType?: SampleShiftCoverage;
}

export interface SampleCollectionMetricsResponse {
  kpi: SampleCollectionKpi;
  planProgress: SampleCollectionPlanProgress | null;
  timeSeries: SampleCollectionTimePeriod[];
  agentGroups: SampleCollectionAgentGroup[];
  segWorkforce: SegWorkforce[];
}

export interface SegWorkforce {
  segId: string;
  numberOfWorkers: number;
  numberOfContractors: number;
}

export interface SampleCollectionKpi {
  totalCollected: number;
  personalCount: number;
  areaCount: number;
  yoyChangePercent: number | null;
}

export interface SampleCollectionPlanProgress {
  currentCount: number;
  targetCount: number | null;
  percentage: number | null;
}

export interface SampleCollectionTimePeriod {
  period: string;
  total: number;
  priorTotal: number | null;
  series: SampleCollectionSeries[];
}

export interface SampleCollectionSeries {
  id: string;
  name: string;
  count: number;
  priorCount: number | null;
}

export interface SampleCollectionAgentGroup {
  id: string;
  name: string;
}

export interface BreakdownItem {
  id: string;
  name: string;
  currentYtd: number;
  priorYtd: number;
  yoyChangePercent: number | null;
}
